import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import "primereact/resources/primereact.min.css";                 
import "primeicons/primeicons.css";                              
import './Base/Styles/PPF_dark.scss';
import './Base/Styles/PPF_light.scss';
import './Styles/styles.scss';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
